import { z } from 'zod';

export const CUSTOMER_USER_PASSWORD_RESET_TOKEN_PAYLOAD_TYPE = 'CustomerUserPasswordResetToken';

export const CustomerUserPasswordResetTokenPayloadSchema = z.object({
    type: z.literal(CUSTOMER_USER_PASSWORD_RESET_TOKEN_PAYLOAD_TYPE),
    userId: z.string(),
});

export type CustomerUserPasswordResetTokenPayload = Readonly<z.infer<typeof CustomerUserPasswordResetTokenPayloadSchema>>;
